"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _ContentCurationItem = _interopRequireDefault(require("../content-curation/ContentCurationItem"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Answer = _interopRequireDefault(require("@insided/destination/icons/Answer"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _Bug = _interopRequireDefault(require("@insided/destination/icons/Bug"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FeaturedTopicsListAsRecommended = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FeaturedTopicsListAsRecommended, _Component);

  var _super = _createSuper(FeaturedTopicsListAsRecommended);

  function FeaturedTopicsListAsRecommended() {
    var _this;

    (0, _classCallCheck2.default)(this, FeaturedTopicsListAsRecommended);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topics: []
    });
    return _this;
  }

  (0, _createClass2.default)(FeaturedTopicsListAsRecommended, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadTopics();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "loadTopics",
    value: function () {
      var _loadTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.get("/events/".concat(this.props.eventId, "/featuredTopics"), {
                  params: {
                    as: 'recommended'
                  }
                });

              case 3:
                res = _context2.sent;
                this.setState({
                  topics: res.data.content
                });
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _logger.logger.error(_context2.t0, {
                  component: 'FeaturedTopicsListAsRecommended',
                  action: 'loadTopics'
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function loadTopics() {
        return _loadTopics.apply(this, arguments);
      }

      return loadTopics;
    }()
  }, {
    key: "render",
    value: function render() {
      var topics = this.state.topics;
      if (topics.length === 0) return null;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var topicType = {
        question: (0, _preact.h)(_Question.default, {
          width: 13.33,
          height: 13.33
        }),
        article: (0, _preact.h)(_Article.default, {
          width: 13.33,
          height: 13.33
        }),
        answer: (0, _preact.h)(_Answer.default, {
          width: 13.33,
          height: 13.33
        }),
        discussion: isBugContentTypeEnabled ? (0, _preact.h)(_Bug.default, {
          width: 13.33,
          height: 13.33
        }) : (0, _preact.h)(_Discussion.default, {
          width: 13.33,
          height: 13.33
        }),
        idea: (0, _preact.h)(_Idea.default, {
          width: 13.33,
          height: 13.33
        })
      };
      return (0, _preact.h)("div", {
        className: "event-featured-topics-as-recommended"
      }, (0, _preact.h)("div", {
        className: "event-featured-topics-as-recommended__header-label"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.featured.topics"
      })), (0, _preact.h)("ul", {
        className: "event-featured-topics-as-recommended__topics-list"
      }, topics.map(function (item, idx) {
        item.icon = topicType[item.type];
        item.idx = idx;
        return (0, _preact.h)(_ContentCurationItem.default, (0, _extends2.default)({
          key: idx
        }, item));
      })));
    }
  }]);
  return FeaturedTopicsListAsRecommended;
}(_preact.Component);

var _default = FeaturedTopicsListAsRecommended;
exports.default = _default;